import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo10 } from "../../../routes/Module10";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo10/nota1.png";
import Imagen2 from "../../../images/modulo10/nota2.png";
import Imagen3 from "../../../images/modulo10/nota3.png";
import Imagen4 from "../../../images/modulo10/nota4.png";
import Imagen5 from "../../../images/modulo10/nota5.png";
import Imagen6 from "../../../images/modulo10/nota6.png";
import Imagen7 from "../../../images/modulo10/nota7.png";
import Imagen8 from "../../../images/modulo10/nota8.png";

import GuiaDocente from "../../../components/GuiaDocente";
import Modulo10Act7 from "../../../DnD/modulo10Act7";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo10/Actividad 7.mp3";

const Actividad7 = () => {
  const infoUnidad = modulo10.content[0];
  const infoAct = modulo10.content[0].activities[6];
  const crumbs = [
    {
      title: modulo10.title,
      url: "/" + modulo10.url,
    },
    {
      title:
        modulo10.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo10.content[0].activities[7].name}`,
    linkNext: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[7].path}`,
    titlePrev: `${modulo10.content[0].activities[5].name}`,
    linkPrev: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[5].path}`,
  };
  const metadata = {
    color: modulo10.color,
    title: `${modulo10.title} - ${infoAct.name}`,
    name: modulo10.title,
  };
  const items = [
    <img src={Imagen1} alt="propuestas" className="img-fluid ms-4 w-140" />,
    <img src={Imagen2} alt="propuestas" className="img-fluid ms-4 w-140" />,
    <img src={Imagen3} alt="propuestas" className="img-fluid ms-4 w-140" />,
    <img src={Imagen4} alt="propuestas" className="img-fluid ms-4 w-140" />,
    <img src={Imagen5} alt="propuestas" className="img-fluid ms-4 w-140" />,
    <img src={Imagen6} alt="propuestas" className="img-fluid ms-4 w-140" />,
    <img src={Imagen7} alt="propuestas" className="img-fluid ms-4 w-140" />,
    <img src={Imagen8} alt="propuestas" className="img-fluid ms-4 w-140" />,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo10.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-12 p-0">
          <ul>
            <li>
              En los recuadros de colores aparecen algunas acciones que los
              congresistas pueden hacer y otras que no pueden hacer.
            </li>
            <li>Colócalas en el espacio que corresponda. </li>
          </ul>

          <div className="ms-md-3 mt-4">
            <Modulo10Act7 items={items} />

            <p>
              <small>(Tomado de www.transparencia.org.pe).</small>
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y los ejemplos de acciones que pueden y no pueden
          realizar los congresistas. Dialoguen al respecto y ayude a resolver la
          actividad. Las acciones que no corresponden a los congresistas son
          construir un puente, ayudar a encontrar trabajo, recibir regalos y
          favorecer a alguien en un juicio.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
